import React from 'react';
import { Grid } from '@material-ui/core';

import { FullScreenCard, Loading } from 'components';
import useSubscription from 'hooks/useSubscription';

import SubscriptionTable from './components/SubscriptionTable';
import LoginCredentials from './components/LoginCredentials';
import PaymentDetails from './components/PaymentDetails';

const Settings: React.SFC = () => {
  const { loading, subscription } = useSubscription();

  if (loading || !subscription) {
    return (
      <FullScreenCard hideLogo size="mini" isNested>
        <Loading message="Loading..." />
      </FullScreenCard>
    );
  }

  return (
    <>
      <Grid item md={6} xs={12}>
        <Grid container direction="column" spacing={4}>
          <Grid item>
            <LoginCredentials />
          </Grid>
          <Grid item>
            <PaymentDetails />
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={6} xs={12}>
        <SubscriptionTable />
      </Grid>
    </>
  );
};

export default Settings;
